import ComponentLinkView from './ComponentLinkView';

export default ComponentLinkView.extend({
  tagName: 'span' // Avoid Firefox bug with label editing #2332
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/dom_components/view/ComponentLabelView.js